module.exports = __webpack_public_path__ + "img/icon-data01.5178da68.png";